import { Expose } from 'class-transformer';
import { SnapshotDisplayMode } from '../../constants/signature-field-displaymodes';
import { DocumentListExtended } from '../document-list.entity';

//TODO: may need to consider formatting options in here to display income/assets and potentially other fields that require custom layouts
export class DvSnapshotValue {
  @Expose()
  fieldName?: string; //field name "firstName"
  @Expose()
  label?: string; //question label “First Name“
  @Expose()
  value?: string; //user input “John”

  //below is to handle collection of values
  @Expose()
  valueCollection?: DvSnapshotValue[]; //if we ever need to store multiple values or sub questions, we can store them here as a collection of snapshot fields.
  @Expose()
  headerCollection?: string[]; //if we need to display income/assets in a grid, we can display this collection as header, and layout the valueCollection under it in order.

  //below is to handle if we need to display documents
  @Expose()
  documentList?: DocumentListExtended; //do not include optouts, only documents uploaded

  @Expose()
  documentsPersonal?: DocumentListExtended; //personal documents only

  @Expose()
  documentsSpouse?: DocumentListExtended; //spouse documents only

  @Expose()
  displayMode?: number = SnapshotDisplayMode.Normal; //customization options to display data in different ways

  @Expose()
  subHeader?: string;

  @Expose()
  questionHeader?: string; //Add simple question header (same font style as question)
}
